import {createContext, ReactElement, useMemo} from 'react';
import ApiClient from '../../infrastructure/remote/sacmi/dto/ApiClient';
import {BulletinRepository} from '../../module/bulletin/domain/repository/BulletinRepository';
import {SummaryRepository} from '../../module/bulletin/domain/repository/SummaryRepository';
import {ApiBulletinRepository} from '../../module/bulletin/infrastructure/repository/api/ApiBulletinRepository';
import {ApiSummaryRepository} from '../../module/bulletin/infrastructure/repository/api/ApiSummaryRepository';

export interface DependencyInjection {
    bulletinRepository: BulletinRepository;
    summaryRepository: SummaryRepository;
}

export const DependencyInjectionContext =
    createContext<DependencyInjection | null>(null);

type Props = {
    children: ReactElement;
}

export const DependencyInjectionProvider = (props: Props): ReactElement => {
    const apiClient = ApiClient();

    const stateValues = useMemo(() => {
        const bulletinRepository = new ApiBulletinRepository(apiClient);
        const summaryRepository = new ApiSummaryRepository(apiClient);
        return { bulletinRepository, summaryRepository };
    }, [apiClient]);

    return (
        <DependencyInjectionContext.Provider value={stateValues}>
            {props.children}
        </DependencyInjectionContext.Provider>
    );
}